// extracted by mini-css-extract-plugin
export var container = "_hp-1";
export var cornerButtonContainer = "_hp-6";
export var disabled = "_hp-2";
export var dragActive = "_hp-3";
export var fileContainer = "_hp-5";
export var hiddenInput = "_hp-4";
export var widthContainer = "_hp-0";